import React, { useState } from 'react';
import { Box, Text, Image, Center } from '@chakra-ui/react';

import WithAnimation from '@/components/Common/WithAnimation';
import useGuestInfo from '@hooks/useGuestInfo';
import ImagesViever from '@components/Common/ImagesViewer';
import LazyImage from '@components/Common/LazyImage';

import { IMG_WELCOMING_SECTION, BG_COVER, IMG_LOGO_US } from '@/constants/assets';

const IMG_URL = `https://user-images.githubusercontent.com/106049860/181873643-760abac5-c4d6-4af7-817c-8e516d2de8e4.jpeg`;

function Welcome() {
  const { name } = useGuestInfo();
  const [imageUrl, setImageUrl] = useState('');

  return (
    <Box>
      <Box bgColor="bgPrimary" bgImage={`url(${BG_COVER})`} bgSize="cover" textAlign="center" color="mainColorText">
        <Box padding="42px 32px 0 32px" fontSize="md">
          <Center>
            <WithAnimation>
              <Image src={IMG_LOGO_US} maxW="200px" />
            </WithAnimation>
          </Center>
          <WithAnimation>
            <Text margin="16px 0" letterSpacing="2px" fontSize="xs" lineHeight="1.8">
              <b>1 - 3 AGUSTUS 2022</b> <br /> PONCOWATI BALLROOM < br />PATRA HOTEL & CONVENTION
            </Text>
          </WithAnimation>
          {/* Image Section */}
          <Center>
            <WithAnimation>
              <Box padding="0 2px">
                <Image src={IMG_WELCOMING_SECTION} maxW="250px" />
              </Box>
            </WithAnimation>
          </Center>
        </Box>
        <Box borderTop="2px solid white" borderBottom="2px solid white" textAlign="center" fontSize="sm" bgColor="bgSecondary" padding="16px 32px">
          <Text fontSize="xs">Kepada Yth. Bapak/Ibu/Saudara/i</Text>
          <Text fontSize="xs">{name || 'Tamu Undangan'}</Text>
        </Box>
      </Box>
      <Box bgColor="bgPrimary" padding="52px 32px">
        <WithAnimation>
          <Text color="mainColorText" fontSize="sm" lineHeight="1.6">
            <b>Patra Wedding Expo</b> bertajuk <i>Unforgettable Sweetness Moment</i> adalah event yang sarat dengan edukasi dan sharing moment dari para vendor dan asosiasi untuk para calon mempelai pernikahan, dengan tujuan calon pengantin dapat mempersiapkan Upacara Pernikahan dengan maksimal dan menjadi moment kenangan termanis pada salah satu bagian terpenting dalam perjalanan hidup mereka. <br /> <br />
            Selain itu event ini penuh dengan referensi vendor dan asosiasi yang rekomended dalam rangkaian proses pernikahan, <b>lebih dari 30 vendor dan asosiasi</b> akan hadir dan berpartisipasi dalam event tersebut.
          </Text >
        </WithAnimation>
        <WithAnimation>
          <LazyImage width="100%" borderRadius="16px" marginTop="24px" boxShadow="md" src={IMG_URL} onClick={() => setImageUrl(IMG_URL)} />
          {imageUrl && <ImagesViever firstIndex={0} images={[IMG_URL]} onClose={() => setImageUrl('')} />}
        </WithAnimation>
      </Box >
    </Box >
  );
}

export default React.memo(Welcome);
